import {AxiosError} from 'axios';
import {POST_CHECK_USER_GROUP_NAME_URL} from 'web-library/constants/apiUrls';
import {
  CheckGroupNameRequestBody
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCheckUserGroupName = ({onError, onSuccess}: Input = {}) => {
  const postCheckUserGroupName = async (reqBody: CheckGroupNameRequestBody) => {
    const res = await axiosClient.post<void>(POST_CHECK_USER_GROUP_NAME_URL, {
      q: reqBody.q,
    });

    return res.data;
  };

  return useCustomMutation(
      postCheckUserGroupName,
      {
        onSuccess,
        onError,
      },
      true,
      false
  );
};
